import {decode, encode} from 'core/common/utils/textEncoderLite';
import Base64 from 'base64-js';

export function capitalizeFirstLetter(str: string) {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str;
  }

}


export function encodeString(str: string): string {
  let uint8array = encode(str);
  return Base64.fromByteArray(uint8array);
}

export function decodeString(base64String: string): string {
  let uint8array = Base64.toByteArray(base64String);
  return decode(uint8array);
}


export function acronym(str: string, maxLength: number = 0) {
  let acronym = str.match(/\b(\w)/g).join('');
  return (maxLength) ? acronym.substr(0, maxLength) : acronym;
}


export function abbreviate(str: string, maxLength: number) {
  return (str) ? ((str.length > maxLength) ? str.substr(0, maxLength-1) + '...' : str) : str;
};


export function chunkString(str: string, length: number, pad: string): string {
  return (str) ? str.match(new RegExp('.{1,' + length + '}', 'g')).join(pad) : str;
}

export function splitByLastSubstring(src: string) : [string, string] {
  if (!src) {
    return null;
  } else {
    let lastIndex = src.lastIndexOf('_');
    return [src.substr(0, lastIndex), src.substr(lastIndex + 1)];
  }
}

export function splitAndTrim(str: string, splitter: string): string[] {
  return (str == null) ? null : str.split(splitter).filter(s => !!s).map(s => s.trim());
}



// WEBPACK FOOTER //
// ./src/core/common/utils/stringUtils.ts